const footerModule = (() => {
    const init = (containerId = 'footersd') => {
        const container = document.getElementById(containerId);
        if (!container) return;
        const footerText = getI18n('footerText');
        const generateFromJobPosting = getI18n('generateFromJobPosting');
        const generateResumeFromText = getI18n('generateResumeFromText');
        const generateCoverLetter = getI18n('generateCoverLetter');
        const atsChecker = getI18n('atsChecker');
        const faqs = getI18n('faqs');
        const pricing = getI18n('pricing');
        const contactUs = getI18n('contactUs');
        const ourStory = getI18n('ourStory');
        const sitemap = getI18n('sitemap');
        const emailUs = getI18n('emailUs');
        const companyAddress = getI18n('companyAddress');
        const phoneNumber = getI18n('phoneNumber');
        const privacyPolicy = getI18n('privacyPolicy');
        const termsConditions = getI18n('termsConditions');
        const rightsReserved = getI18n('rightsReserved.');
        const siteName = getSiteName();
        const brandSiteName = getBrandName();
        const footerTextCon = getI18n('footerTextCont');
        const quickLinks =  getI18n('quickLinks');
        const explore =  getI18n('explore');
        const ourOffice =  getI18n('ourOffice');
        const localeLang = getLanguage();




        container.innerHTML = `
        <div class="horizontalsd" style="padding-top: 0.5rem;">
          <footer class="mn-footer">
            <div class="container">
              <div class="row g-4">
                <div class="col-xl-4 col-lg-3 col-md-6 mt-4">
                  <div class="mn-footer-widget">
                    <div class="mn-footer-logo">
                      <a href="/" onclick="handleNavigation(event, '/')"><svg style="height: 48px; width: 48px;color: #ce3717;"><use href="#icon-resumeInMinutes"></use></svg></a>
                    </div>
                    <p class="mn-footer-description">
                      ${footerText} ${brandSiteName} ${footerTextCon}
                    </p>
                    <div class="mn-footer-socials mt-3">
                      <a href="#"><svg class="mn-social-icon"><use href="#icon-instagram"></use></svg></a>
                      <a href="https://www.facebook.com/resumeinminutes" target="_blank"><svg class="mn-social-icon"><use href="#icon-facebook"></use></svg></a>
                      <a href="#"><svg class="mn-social-icon"><use href="#icon-twitter"></use></svg></a>
                      <a href="#"><svg class="mn-social-icon"><use href="#icon-linkedin"></use></svg></a>
                      <a href="https://www.youtube.com/channel/UCwSC4dVX_hh7GmspSWfx7jQ" target="_blank"><svg class="mn-social-icon-youtube"><use href="#youtube-icon"></use></svg></a>
                    </div>
                  </div>
                </div>

                <div class="col-xl-3 col-lg-4 col-md-6 mt-4">
                  <div class="mn-footer-widget">
                    <h4>${quickLinks}</h4>
                    <ul>
                      <li><svg class="icon-md footer-svg"><use href="#icon-star"></use></svg><a href="/${localeLang}/generate-resume-from-job-posting" onclick="handleNavigation(event, '/${localeLang}/generate-resume-from-job-posting')">${generateFromJobPosting}</a></li>
                      <li><svg class="icon-md footer-svg"><use href="#icon-job-criteria"></use></svg><a href="/${localeLang}/generate-resume-from-text" onclick="handleNavigation(event, '/${localeLang}/generate-resume-from-text')">${generateResumeFromText}</a></li>
                      <li><svg class="icon-md footer-svg"><use href="#icon-document"></use></svg><a href="/${localeLang}/generate-coverletter" onclick="handleNavigation(event, '/${localeLang}/generate-coverletter')">${generateCoverLetter}</a></li>
                      <li class="production-june"><svg class="icon-md footer-svg"><use href="#icon-ats-tracker"></use></svg><a href="/${localeLang}/resume-ats-checker" onclick="handleNavigation(event, '/${localeLang}/resume-ats-checker')">${atsChecker}</a></li>
                    </ul>
                  </div>
                </div>

                <div class="col-xl-2 col-lg-2 col-md-6 mt-4">
                  <div class="mn-footer-widget">
                    <h4>${explore}</h4>
                    <ul>
                      <li><svg class="icon-md footer-svg"><use href="#icon-pricing"></use></svg><a href="/${localeLang}/pricing" onclick="handleNavigation(event, '/${localeLang}/pricing')">${pricing}</a></li>
                      <li><svg class="icon-md footer-svg"><use href="#icon-contactus"></use></svg><a href="/${localeLang}/contactus" onclick="handleNavigation(event, '/${localeLang}/contactus')">${contactUs}</a></li>
                      <li><svg class="icon-md footer-svg"><use href="#icon-ourstory"></use></svg><a href="/${localeLang}/contactus" onclick="handleNavigation(event, '/${localeLang}/contactus')">${ourStory}</a></li>
                      <li><svg class="icon-md footer-svg"><use href="#icon-faqs"></use></svg><a href="/${localeLang}/faqs" onclick="handleNavigation(event, '/${localeLang}/faqs')">${faqs}</a></li>
                      <li><svg class="icon-md footer-svg"><use href="#icon-sitemap"></use></svg><a href="/${localeLang}/sitemap" onclick="handleNavigation(event, '/${localeLang}/sitemap')">${sitemap}</a></li>
                    </ul>
                  </div>
                </div>

                <div class="col-lg-3 col-md-6 mt-4">
                  <div class="mn-footer-widget">
                    <h4>${ourOffice}</h4>
                    <ul>
                      <li><svg class="icon-md footer-svg" style="align-self: flex-start; margin-top: 3.5px;"><use href="#usaflag-icon"></use></svg>${companyAddress}</li>
                      <li><svg class="icon-md footer-svg"><use href="#icon-mail"></use></svg><a href="/ourstory" onclick="handleNavigation(event, '/contactus')">${emailUs}</a></li>
                      <li><svg class="icon-md footer-svg"><use href="#icon-phone"></use></svg><a href="tel:18007584921">${phoneNumber}</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
       <div class="mn-footer-bottom">
            <svg class="icon-md"><use href="#icon-security"></use></svg>
            <a href="javascript:void(0)" onclick="staticModalModule.init('/dist/custom/js/data/html/privacypolicy-' + getLanguage() + '.html','staticModalContainer',event)">${privacyPolicy}</a>

            <svg class="mn-separator-dot" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="3" fill="#555" />
            </svg>

            <svg class="icon-md"><use href="#icon-terms"></use></svg>
            <a href="javascript:void(0)" onclick="staticModalModule.init('/dist/custom/js/data/html/terms-' + getLanguage() + '.html', 'staticModalContainer', event)">${termsConditions}</a>

            <svg class="mn-separator-dot" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="3" fill="#555" />
            </svg>

            <svg class="icon-md" style="color: var(--text-primary);"><use href="#icon-resumeInMinutes"></use></svg>
            ${siteName}. ${rightsReserved}
            </div>

        <div class="footer-seperator-bottom">
            &nbsp;
          </div>
      `;
    };

    return { init };
})();

export default footerModule;